<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="Object.assign({}, attrs, $attrs)" v-on="on">
        <v-icon>{{ icon }}</v-icon>
        {{ text }}
      </v-btn>
    </template>
    <v-list nav dense>
      <v-list-item-group v-model="selection" color="primary">
        <template v-for="(item, i) in itens">
          <v-divider v-if="i > 0" :key="i" />
          <v-list-item :key="itemId(item)">
            <v-list-item-content>
              <v-list-item-title v-text="itemText(item)"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import Vue from "vue";

export default Vue.component("tj-dropdown", {
  model: {
    prop: "value",
    event: "update"
  },
  props: {
    idCol: {
      type: String,
      default: "id"
    },

    textCol: {
      type: String,
      default: "text"
    },

    icon: String,
    itens: Array,
    value: [String, Number]
  },

  computed: {
    selection: {
      get() {
        return this.getItemIndex(this.value);
      },
      set(v) {
        console.log("tj-dropdown update", v);
        this.$emit("update", this.itemId(this.itens[v]));
      }
    },

    text() {
      return this.itemText(this.getItemById(this.value));
    },

    itemText() {
      const col = this.textCol;
      return v => {
        if (v == null) return null;
        return v[col] != null ? v[col] : v;
      };
    },

    itemId() {
      const col = this.idCol;
      return v => {
        if (v == null) return null;
        return v[col] != null ? v[col] : v;
      };
    }
  },

  methods: {
    getItemById(v) {
      const itemId = this.itemId;
      return this.itens.find(item => itemId(item) === v);
    },

    getItemIndex(id) {
      const itemId = this.itemId;
      return this.itens.findIndex(item => itemId(item) === id);
    }
  }
});
</script>
